const NoPage = () => {
  return (
    <h1 className="mt-10 text-size:xl xs:text-size-4xl mx-auto">
      Yeah, nah. 404
    </h1>
  );
};

export default NoPage;
